import { AssetType, NODE_TYPES } from '@metavrse-inc/metavrse-lib';

export const uploadableToConvertionAssetTypes: Record<string, AssetType> = {
  // fbx: NODE_TYPES.object,
  // obj: NODE_TYPES.object,
  // glb: NODE_TYPES.object,
  // gltf: NODE_TYPES.object,
};
